module.exports = __webpack_public_path__ + "article-7051a3ee/lebenslauf-schueler-75153b2f12fbb60d6558c28041faba11.jpg";